import traits from "config/traits.csv";

const useTraitsInWallet = (
  address?: string
): [traits: number[], readTraitsInWallet: () => void] => {
  const traitsInWallet = traits.map(([tokenId]) => tokenId);
  return [traitsInWallet, () => {}];
};

export default useTraitsInWallet;
